import { arrayOrEmpty } from '@/utilities/helpers';

export default function ReservationFields(settings: Locations.Settings = {} as Locations.Settings) {
	const reservationFields = settings.booking_collectible_fields || {};
	const additionalFields = arrayOrEmpty(settings.booking_additional_fields) as Locations.AdditionalField[];

	const collectibleFields = Object.keys(reservationFields)
		.filter((key) => {
			const type = typeof reservationFields[key] === 'string' ? reservationFields[key] : reservationFields[key].type;
			return type === 'collect' || type === 'require';
		});

	const requiredFields = Object.keys(reservationFields)
		.filter((key) => {
			const type = typeof reservationFields[key] === 'string' ? reservationFields[key] : reservationFields[key].type;
			return type === 'require';
		});

	const renamedFields = Object.keys(reservationFields)
		.filter((key) => !(typeof reservationFields[key] === 'string') && reservationFields[key].name !== '');

	function fetchName(key: string): any {
		return renamedFields.includes(key) ? reservationFields[key].name : false;
	}

	function isRequired(key: string): boolean {
		return requiredFields.includes(key);
	}

	function isCollected(key: string): boolean {
		return collectibleFields.includes(key);
	}

	return {
		additionalFields,
		collectibleFields,
		renamedFields,
		requiredFields,
		fetchName,
		isRequired,
		isCollected,
	};
}
